export default {
    rules: (wrapper) => ({
        name: {label: wrapper.$t('field.name'), required: true, },
    }),
};
